import { useEffect } from 'react';
import { StepShell } from '../components/layout';
import { RankList } from '../components/selection';
import { TextArea } from '../components/inputs';

export default function DepartmentPrefsStep({ data, update, notes = {}, config }) {
  const departments = config.departments;
  const ranking = data.ranking?.length ? data.ranking : null;

  // Seed the ranking on first visit so there is something to drag.
  useEffect(() => {
    if (!ranking) update({ ranking: departments.map((d) => d.key) });
  }, [ranking, departments, update]);

  const order = ranking || departments.map((d) => d.key);
  const topChoice = departments.find((d) => d.key === order[0]);

  return (
    <StepShell
      eyebrow="Step 16 of 18"
      title="Choose your direction"
      lede="Five places you could land. Put them in the order that appeals to you most — drag them around, or use the arrows."
      why="Your ranking carries real weight in where you are placed. We will not put you somewhere you ranked last."
      encouragement="Nothing here is closed off to you. Rank on what interests you, not on what you think you are qualified for."
    >
      <div>
        <div className="ob-group-label">Most appealing at the top</div>
        <RankList
          items={departments}
          order={order}
          onChange={(next) => update({ ranking: next })}
        />
      </div>

      {topChoice && (
        <div className="ob-divider">
          <div className="ob-group-label">About your first choice</div>
          <div className="ob-choice" style={{ cursor: 'default', marginBottom: 16 }}>
            <span
              aria-hidden="true"
              style={{
                width: 4, alignSelf: 'stretch', borderRadius: 4,
                background: topChoice.accent, flexShrink: 0,
              }}
            />
            <span className="ob-choice-text">
              <span className="ob-choice-title">{topChoice.name}</span>
              <span className="ob-choice-hint">{topChoice.description}</span>
            </span>
          </div>

          <TextArea
            id="first_choice_reason"
            label={`What draws you to ${topChoice.name}?`}
            rows={3}
            maxLength={600}
            placeholder="A sentence or two about why this one appeals to you."
            value={data.first_choice_reason}
            note={notes.first_choice_reason || notes.ranking}
            onChange={(v) => update({ first_choice_reason: v })}
          />
        </div>
      )}
    </StepShell>
  );
}
